export default __webpack_public_path__ + "h4.png";